import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import Button from '../../../../../components/global/Button';
import PinField from '../../../../../components/global/PinField';
import WaldoSpeechBubble from '../../../../../components/global/WaldoSpeechBubble';

const propTypes = {
  emailAddress: PropTypes.string.isRequired,
  firstName: PropTypes.string,
  loading: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  onPinCodeResend: PropTypes.func.isRequired,
  values: PropTypes.shape({
    code: PropTypes.string,
  }).isRequired,
};

const PinVerificationStep = ({
  emailAddress,
  firstName,
  loading,
  handleSubmit,
  handleChange,
  onPinCodeResend,
  values,
}) => {
  const isValid = values.code?.length === 4;
  const maskEmail = email => {
    if (!email) return '';
    const [user, domain] = email.split('@');
    if (user.length <= 2) return email;
    return `${user[0]}${'*'.repeat(5)}${user[user.length - 1]}@${domain}`;
  };

  return (
    <Fragment>
      <WaldoSpeechBubble className="w-100-i mx-0 mb-2 text-sm" position="right">
        To ensure the security of {firstName ? `${firstName}'s` : 'your'}{' '}
        photos, please enter the pin code emailed to{' '}
        <span className="text-primary">{maskEmail(emailAddress)}</span> to view
        them.
      </WaldoSpeechBubble>
      <div className="marketing-account-onboarding-pin-step">
        <h2 className="text-center mb-4">Verify your email</h2>

        <form onSubmit={handleSubmit} className="text-center">
          <div className="mb-4">
            <PinField
              autofocus
              onComplete={value => {
                handleChange({
                  target: {
                    name: 'code',
                    value,
                  },
                });
              }}
              onChange={value => {
                handleChange({
                  target: {
                    name: 'code',
                    value,
                  },
                });
              }}
            />
          </div>

          <Button
            type="submit"
            disabled={loading || !isValid}
            loading={loading}
            className="btn-primary w-100 mb-3"
            btnSize="lg"
          >
            Verify email and join event
          </Button>

          <p className="text-muted small mb-2">
            By continuing you agree to <a href="/terms">Terms of Use</a> &{' '}
            <a href="/privacy">Privacy Policy</a>
          </p>

          <p>
            Didn&apos;t get it?{' '}
            <Button
              type="button"
              btnStyle="link"
              disabled={loading}
              className="p-0 align-baseline"
              onClick={onPinCodeResend}
            >
              Resend PIN
            </Button>
          </p>
        </form>
      </div>
    </Fragment>
  );
};

PinVerificationStep.propTypes = propTypes;

export default PinVerificationStep;
